import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { ProviderSignupForm, Button } from '@joinomu/ui'
import { authService } from '@joinomu/shared'

interface ProviderSignupFormData {
  email: string
  password: string
  firstName: string
  lastName: string
  licenseNumber: string
  specialty: string
  phone: string
  licensed: string[]
}

export function ProviderSignupPage() {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSignup = async (data: ProviderSignupFormData) => {
    setLoading(true)
    setError('')

    try {
      const { data: authData, error: signUpError } = await authService.signUp({
        email: data.email,
        password: data.password,
        firstName: data.firstName,
        lastName: data.lastName,
        role: 'provider',
        specialty: data.specialty,
        licenseNumber: data.licenseNumber,
        phone: data.phone,
        licensed: data.licensed
      })

      if (signUpError) throw signUpError

      if (authData.user) {
        // User created successfully, they should be automatically signed in
        // Navigate to provider dashboard
        navigate('/provider/dashboard')
      }
    } catch (error: any) {
      setError(error.message || 'An error occurred during signup')
    }
    
    setLoading(false)
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background py-8 px-4">
      <div className="max-w-2xl w-full">
        <ProviderSignupForm 
          onSubmit={handleSignup}
          loading={loading}
          error={error}
          showLoginLink={true}
          loginElement={
            <Link to="/provider/login" className="text-primary hover:underline">
              Sign in here
            </Link>
          }
        />
        <div className="mt-4 text-center">
          <Button asChild variant="ghost" size="sm">
            <Link to="/">← Back to Home</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}